import { styled } from 'styled-components';

export const DateTimeTagContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
`;

export const DotSeparator = styled.span`
  gap: 0px;
  height: 15px;
  letter-spacing: 0.016em;
  text-align: left;
  width: 7px;
  margin-left: 4px;
  color: ${({ theme }) => theme.colors.accent.primary};
`;
